export default __webpack_public_path__ + "static/jira-d221340fd52cd5a44e60adc5a14df70c.jpg";